import {getFirstDayOfEarliestEditableMonth} from '@nursio-link/common/utils';
import dayjs from 'dayjs';
import {useEffect} from 'react';
import type {UseFormReturn} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {useSearchParams} from 'react-router-dom';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import {Input} from '@/components/ui/input';
import {TIME_FORMATS} from '@/utils/timeFormats';

import TaskTimeInput from '../../../../components/TaskTimeInput';
import {type TaskFormValues, TaskType} from '../../utils/tasksFormInputs';

export type OneTimeTaskFormFieldsProps = {
  form: UseFormReturn<TaskFormValues>;
};

const TaskFormFields = ({form}: OneTimeTaskFormFieldsProps) => {
  const {t} = useTranslation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const dateParam = searchParams.get('date');
    const date = dateParam ? dayjs(dateParam) : dayjs();
    form.setValue(
      'date',
      (date.isValid() ? date : dayjs()).format(TIME_FORMATS.awsDate)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex gap-4 max-sm:flex-col">
      <FormField
        control={form.control}
        name="date"
        render={({field}) => (
          <FormItem className="grow basis-0">
            <FormLabel>{t('Date')}</FormLabel>
            <FormControl>
              <Input
                {...field}
                onChange={field.onChange}
                value={dayjs(field?.value).format(TIME_FORMATS.awsDate)}
                required
                type="date"
                min={getFirstDayOfEarliestEditableMonth()}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      {form.watch('taskType') !== TaskType.Announcement && (
        <FormField
          control={form.control}
          name="time"
          render={({field}) => (
            <FormItem className="grow basis-0">
              <FormLabel required>{t('Time')}</FormLabel>
              <FormControl>
                <TaskTimeInput
                  onChange={field.onChange}
                  isHourInterval={false}
                  value={field.value || ''}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </div>
  );
};

export default TaskFormFields;
